export default __webpack_public_path__ + "static/media/tutor.ef1ba515.md";